<template>
    <div class="editReservationPopupBg" @click.self="pressDone">
        <div class="popupArea bg-lightest px-3 overflow-auto">

            <div class="text-center fs-larger font-weight-600 p-3">
                Edit Extras
            </div>

            <extras-manager class="extrasHolder" :reservation="getSelectedReservation" :extrasArrayImported="copyOfExtras"></extras-manager>

            <div class="col-sm-12 my-2 text-right">
                <button class="btn primary wider ml-2"  @click="pressDone">Done</button>
            </div>


        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
import extendedVSelect from '@/extends/vue-select'

import ExtrasManager from '@/components/reservations/NewReservation/Resume/AddExtra/ExtrasManager'

export default {
    data: function() {
        return {
            copyOfExtras: null
        }
    },
    props:{

    },
    created: function () {
        this.makeCopyOfExtras()
    },
    computed: {
        ...mapGetters([
            'getSelectedReservation'
        ])
    },
    mixins:[
        reservationsMixin
    ],
    methods: {
        makeCopyOfExtras: function () {
            this.copyOfExtras = JSON.parse(JSON.stringify(this.getSelectedReservation.bookingComponents))
        },
        pressDone: function() {
            this.eventHub.$emit('editReservation_toggleEditExtas', this.copyOfExtras);
        },
    },
    components: {
        vSelect: extendedVSelect,
        ExtrasManager
    }
}
</script>

<style lang="scss" scoped>

@import '../../../assets/scss/_variables.scss';

.extrasHolder{
    max-height: 370px;
    overflow-y: auto;
}

.paymentRowsHolder{
    // min-height: 100px;
    max-height: 200px;
    overflow: auto;

    div:nth-child(odd){
        background-color: $lighter;
    }
}

.payMethod{
    width: 103px;
    height: 72px;

    &.selected{
        border-color: $darkest !important;
        border-width: 2px !important;
    }

    &:hover{
        background-color: $lighter;
    }
}



.editReservationPopupBg{
    background-color: rgba(0,0,0,0.5);
    width: 100%;
    max-width: 100%;
    height: 100%;
    z-index: 10;
    position: absolute;
    max-width: 100%;

    .popupArea{
        width: 1000px;
        max-width: 100%;
        max-height: 100%;
        margin: 0 auto;
        overflow: auto;

    }
}



</style>



// WEBPACK FOOTER //
// EditExtras.vue?76612e87